import EditProgramPayment from "../../../../modules/academyProgramPersonalInfo/ui/programStudent/EditProgramPayment";
import { ProgramPaymentType } from "../../../../types/dto/program";
import { WrapperModalAssignedStudentProgram } from "./styled";

export const ModalEditProgramPayment = ({
  openModal,
  setOpenModal,
  payment,
  onSuccess,
}: {
  openModal: boolean;
  setOpenModal: (value: boolean) => void;
  payment: ProgramPaymentType | null;
  onSuccess?: () => void;
}) => {
  if (!payment) return null;

  return (
    <WrapperModalAssignedStudentProgram
      title="Editar pago del estudiante"
      open={openModal}
      width="360px"
      destroyOnClose
      onClose={() => setOpenModal(false)}
    >
      <EditProgramPayment
        payment={payment}
        setOpenModal={setOpenModal}
        onSuccess={onSuccess}
      />
    </WrapperModalAssignedStudentProgram>
  );
};
